import vuei18n from '@/plugins/vue-i18n';
import moment from "moment";
import { backgroundColor } from '@/config/rcm';
import { sanitizeAmount, capitalizeText } from '@/utils/rcm.general.utils'

const getDetailChargeInformation = (chargeList, account, excludedColumns = []) => {
    const patientInformation = [
        {
            header: vuei18n.t("rcm.chargeDetail.patientInformation.patientName"),
            content: chargeList.patientName,
            backgroundColor: backgroundColor.transparentBackgroundColor,
            customCols:{
                required: true,
                colsHeader: {
                    lg: 3,
                    md: 6
                },
                colsContent: {
                    lg: 9,
                    md: 6
                }
            }
        },
        {
            header: vuei18n.t("rcm.chargeDetail.patientInformation.patientId"),
            content: chargeList.patientId,
            backgroundColor: backgroundColor.transparentBackgroundColor,
            customCols:{
                required: false
            }
        },
        {
            header: vuei18n.t("rcm.chargeDetail.patientInformation.patientDocumentType"),
            content: chargeList.patientDocumentType,
            backgroundColor: backgroundColor.transparentBackgroundColor,
            customCols:{
                required: false
            }
        },
        {
            header: vuei18n.t("rcm.chargeDetail.patientInformation.patientDocumentNumber"),
            content: chargeList.patientDocumentNumber,
            backgroundColor: backgroundColor.transparentBackgroundColor,
            customCols:{
                required: false
            }
        },
        {
            header: vuei18n.t("rcm.chargeDetail.patientInformation.eventNumber"),
            content: chargeList.originEventId,
            backgroundColor: backgroundColor.transparentBackgroundColor,
            customCols:{
                required: false
            }
        }
    ]
    const chargeDetail = [
        {
            header: vuei18n.t("rcm.chargeDetail.chargeDetail.createdAt"),
            content: moment.parseZone(chargeList.creationDateTime).format("DD/MM/YYYY"),
        },
        {
            header: vuei18n.t("rcm.chargeDetail.chargeDetail.healthcarePlanCoverage"),
            content: chargeList.healthcarePlanCoverage
        },
        {
            header: vuei18n.t("rcm.chargeDetail.chargeDetail.chargeCode"),
            content: chargeList.code
        },
        {
            header: vuei18n.t("rcm.chargeDetail.chargeDetail.authorizationId"),
            content: chargeList.agreementCode
        },
        {
            header: vuei18n.t("rcm.chargeDetail.chargeDetail.payer"),
            content: chargeList.payerName
        },
        {
            header: vuei18n.t("rcm.chargeDetail.chargeDetail.location"),
            content: chargeList.providerBranchName
        },
        {
            header: vuei18n.t("rcm.chargeDetail.chargeDetail.typeOfService"),
            content: capitalizeText(chargeList.serviceType)
        },
        {
            header: vuei18n.t("rcm.chargeDetail.chargeDetail.quantity"),
            content: chargeList.quantity
        },
        {
            header: vuei18n.t("rcm.chargeDetail.chargeDetail.invoiceNumber"),
            content: account.invoiceNumber || 
                vuei18n.t('rcm.chargeDetail.defaultInformation.defaultInvoiceAmount'),
        },
        {
            header: vuei18n.t("rcm.chargeDetail.chargeDetail.unitValue"),
            content: sanitizeAmount(chargeList.amount)
        },
        {
            header: vuei18n.t("rcm.chargeDetail.chargeDetail.totalAmount"),
            content: sanitizeAmount(chargeList.totalAmount)
        }
    ]

    const diagnosis = {
        diagnosisCode: chargeList.diagnosisCode,
        diagnosisName: capitalizeText(chargeList.diagnosisName)
    }

    const descriptionCharge = `${chargeList.providerProductCode} ${chargeList.description}`;

    const filteredChargeDetail = chargeDetail.filter(detail => 
        !excludedColumns.includes(detail.header.split('.').pop().toUpperCase())
    );

    const chargeDetailInformation = {
        patientInformation,
        chargeDetail:filteredChargeDetail,
        diagnosis,
        descriptionCharge
    }

    return chargeDetailInformation;
}

export {
    getDetailChargeInformation
}